import React from "react";
import ProfessionalismCard from "./professionalism";
import PositiveAttitudeCard from "./positiveAttitude";
import CommunicationCard from "./communication";
import SocialCard from "./social";
import ResumeMatch from "./resumeMatch";

function Behaviour({
  professionalScore,
  positivenessScore,
  communicationScore,
  sociabilityScore,
  comingFrom = "jobPostReport",
}) {
  const professionalismData = {
    title: "Professionalism",
    percentage: professionalScore,
  };

  const positiveAttitudeData = {
    title: "Positive Attitude",
    percentage: positivenessScore,
  };
  const CommunicationData = {
    title: "Communication",
    percentage: communicationScore,
  };
  const sociabilityData = {
    title: "Sociability",
    percentage: sociabilityScore,
  };

  const comingfrom = comingFrom;

  return (
    <div
      className={`${
        comingfrom === "jobpostReport" ? "shadow-lg" : ""
      } bg-white`}
    >
      <h1 className="md:px-4 pt-6 md:ml-8 ml-3 text-xl text-[#0D0D0C] gil-med">
        Behavioural Assessment
      </h1>

      <div className=" md:p-4  pb-4 md:ml-8 m-3 grid grid-cols-2 md:grid-cols-3 gap-2 gil-reg border-b-2  border-dashed border-gray-300">
        <ProfessionalismCard
          title={professionalismData.title}
          percentage={professionalismData.percentage}
        />
        <PositiveAttitudeCard
          title={positiveAttitudeData.title}
          percentage={positiveAttitudeData.percentage}
        />

        {/* <CommunicationCard
          title={CommunicationData.title}
          percentage={CommunicationData.percentage}
        /> */}

        <SocialCard
          title={sociabilityData.title}
          percentage={sociabilityData.percentage}
        />
      </div>

      {/* <div className="md:p-4 md:ml-8 ml-3 border-b-2  border-dashed border-gray-300">
        <ResumeMatch />
      </div> */}
    </div>
  );
}

export default Behaviour;
